import React from "react";
import "./Contact.scss";
import LocationSection from "./sub/LocationSection";
import AA from "../Home/sub/AA";
import SectionTitle from "../../components/SectionTitle/SectionTitle";

export default function Contact() {
  return (
    <>
    <SectionTitle title="Contact" />
    <LocationSection />
    </>
  );
}
